export default __webpack_public_path__ + "static/tick_2-871fa425e1d170ee1cbabfbfeb86efb9.png";